export const SET_SELECTED_AS_OF_DATE = 'selection/SET_SELECTED_AS_OF_DATE';
export const setSelectedAsOfDate = (asOfDate) => ({
  type: SET_SELECTED_AS_OF_DATE,
  asOfDate,
});

export const SET_SYMBOLIC_DATE = 'selection/SET_SYMBOLIC_DATE';
export const setSymbolicDate = (symbolicDate) => ({
  type: SET_SYMBOLIC_DATE,
  symbolicDate,
});

export const SET_SELECTED_ACCOUNT_ENTITY_ID = 'selection/SET_SELECTED_ACCOUNT_ENTITY_ID';
export const setSelectedAccountEntityId = (accountEntityId) => ({
  type: SET_SELECTED_ACCOUNT_ENTITY_ID,
  accountEntityId,
});

export const SET_SELECTED_BENCHMARK_ENTITY_ID = 'selection/SET_SELECTED_BENCHMARK_ENTITY_ID';
export const setSelectedBenchmarkEntityId = (benchmarkEntityId) => {
  return {
    type: SET_SELECTED_BENCHMARK_ENTITY_ID,
    benchmarkEntityId,
  };
};

export const SET_SELECTED_GROUPING_LEVELS = 'selection/SET_SELECTED_GROUPING_LEVELS';
export const setSelectedGroupingLevels = (groupingLevels) => {
  return {
    type: SET_SELECTED_GROUPING_LEVELS,
    groupingLevels,
  };
};

export const SET_SCENARIOS_VALUE = 'selection/SET_SCENARIOS_VALUE';
export const setScenariosValue = (value) => ({
  type: SET_SCENARIOS_VALUE,
  value,
});

export const SET_BENCHMARK_SCENARIOS_VALUE = 'selection/SET_BENCHMARK_SCENARIOS_VALUE';
export const setBenchmarkScenariosValue = (value) => ({
  type: SET_BENCHMARK_SCENARIOS_VALUE,
  value,
});

export const SET_SIDE_BY_SIDE = 'selection/SET_SIDE_BY_SIDE';
export const setSideBySide = (value) => ({
  type: SET_SIDE_BY_SIDE,
  value,
});

export const SET_DISABLE_BMARK_WORKSPACE = 'selection/SET_DISABLE_BMARK_WORKSPACE';
export const setIsDisableBenchmarkWorkspace = (value) => ({
  type: SET_DISABLE_BMARK_WORKSPACE,
  value,
});




export const SET_SELECTED_GROUPING_LEVEL_FILTERS = 'selection/SET_SELECTED_GROUPING_LEVEL_FILTERS';
export const setSelectedGroupingLevelsFilters = (groupingLevelsFilters) => {
  return {
    type: SET_SELECTED_GROUPING_LEVEL_FILTERS,
    payload: { groupingLevelsFilters }
  };
};
export const NEW_GROUPING_LEVELS_FILTER = 'selection/NEW_GROUPING_LEVELS_FILTER';
export const newGroupingLevelsFilter = () => {
  return {
    type: NEW_GROUPING_LEVELS_FILTER,
  };
};
export const SET_GROUPING_LEVELS_FILTER_INCLUDE_EXCLUDE = 'selection/SET_GROUPING_LEVELS_FILTER_INCLUDE_EXCLUDE';
export const setGroupingLevelFilterIncludeExclude = (idx, includeExclude) => {
  return {
    type: SET_GROUPING_LEVELS_FILTER_INCLUDE_EXCLUDE,
    payload: { idx, includeExclude },
  };
};

export const SET_GROUPING_LEVELS_FILTER_LEVEL = 'selection/SET_GROUPING_LEVELS_FILTER_LEVEL';
export const setGroupingLevelFilterLevel = (idx, level) => {
  return {
    type: SET_GROUPING_LEVELS_FILTER_LEVEL,
    payload: { idx, level },
  };
};

export const SET_GROUPING_LEVELS_FILTER_LEVEL_KEYS = 'selection/SET_GROUPING_LEVELS_FILTER_LEVEL_KEYS';
export const setGroupingLevelFilterLevelKeys = (idx, levelKeys) => {
  return {
    type: SET_GROUPING_LEVELS_FILTER_LEVEL_KEYS,
    payload: { idx, levelKeys },
  };
};

export const SET_GROUPING_LEVELS_FILTER_REWEIGHT = 'selection/SET_GROUPING_LEVELS_FILTER_REWEIGHT';
export const setGroupingLevelFilterReweight = (reweight) => {
  return {
    type: SET_GROUPING_LEVELS_FILTER_REWEIGHT,
    payload: { reweight },
  };
};

export const REMOVE_GROUPING_LEVELS_FILTER = 'selection/REMOVE_GROUPING_LEVELS_FILTER';
export const removeGroupingLevelFilter = (idx) => {
  return {
    type: REMOVE_GROUPING_LEVELS_FILTER,
    payload: { idx },
  };
};
export const SET_SECURITY_LABEL = 'selection/SET_SECURITY_LABEL';
export const setSecurityLabel = (securityLabel) => {
  return {
    type: SET_SECURITY_LABEL,
    securityLabel,
  }
};

export const SET_IS_LOOKTHRU = 'selection/SET_IS_LOOKTHRU';
export const setSelectedIsLookthru = (isLookthru) => {
  return {
    type: SET_IS_LOOKTHRU,
    isLookthru,
  };
};

export const SET_IS_DEFAULT_BENCHMARK = 'selection/SET_IS_DEFAULT_BENCHMARK';
export const setSelectedIsDefaultBenchmark = (isDefaultBenchmark) => {
  return {
    type: SET_IS_DEFAULT_BENCHMARK,
    isDefaultBenchmark,
  };
};

export const SET_MIN_BENCH_WEIGHT = 'selection/SET_MIN_BENCH_WEIGHT';
export const setMinBenchWeight = (minBenchWeight) => {
  return {
    type: SET_MIN_BENCH_WEIGHT,
    minBenchWeight,
  };
};

export const SET_MIN_ACC_WEIGHT = 'selection/SET_MIN_ACC_WEIGHT';
export const setMinAccWeight = (minAccWeight) => {
  return {
    type: SET_MIN_ACC_WEIGHT,
    minAccWeight,
  };
};

export const COMMIT_SELECTIONS = `selection/COMMIT_SELECTIONS`;
export const commitSelections = () => ({
  type: COMMIT_SELECTIONS,
});

